// extracted by mini-css-extract-plugin
module.exports = {"standard":"_3ea6fa5da8--standard--Vr__n","light":"_3ea6fa5da8--light--nOps1","outline":"_3ea6fa5da8--outline--gQuOj"};